var $50c5b1f4c942e0c9$exports = {};
$50c5b1f4c942e0c9$exports = {
    "info": `Informa\xe7\xe3o`,
    "negative": `Erro`,
    "notice": `Aviso`,
    "positive": `Sucesso`
};


export {$50c5b1f4c942e0c9$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
